import { svgs } from "../../../../assets";

interface IStepConfig {
  [key: number]: {
    title: string;
    image: string;
    text: string;
  };
}

const stepConfig: IStepConfig = {
  1: {
    title: "Cadastro",
    image: svgs.PlusSignGuy,
    text: "Realize seu cadastro para criar a conta",
  },
  2: {
    title: "Planos",
    image: svgs.Plans,
    text: "Escolha o plano ideal para você",
  },
  3: {
    title: "Adesão",
    image: svgs.Contract,
    text: "Aceite os termos para continuar",
  },
  4: {
    title: "Cadastro em Análise",
    image: svgs.Clock,
    text: "Após a análise, você poderá acessar a plataforma",
  },
};

export default stepConfig;
